// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LoadingSpinner_spinner__VZvhC","spin":"LoadingSpinner_spin__2ov_s"};